import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "../../services/store.service";
import { SystemProperties } from "../../models/system-properties";
import { BaseError } from "../pages/base-error";
import { ToastrService } from "ngx-toastr";
import { SystemPropertiesControllerService } from "../../services/system-settings/system-properties-controller.service";
import { Context } from "../../models/context";
import { TranslateService } from "@ngx-translate/core";
import { Institution } from "../../models/institution";

enum PaneToShow {
  ADD, SEARCH, SHOW,
}

@Component({
  selector: "app-list-grid",
  templateUrl: "./list-grid.component.html",
  styleUrls: ["./list-grid.component.css"],
  providers: [],
})
export class ListGridComponent extends BaseError implements OnChanges, OnInit, OnDestroy {
  @Input() public items: any[];
  @Input() public headingText: string;
  @Input() public elementsNumber: string;
  @Input() public headingTextSize: string = "BIG";
  @Input() public isDeterminantTable: boolean;
  @Input() public isMessagesTable: boolean;
  @Input() public rolesFlow: boolean = false;
  @Input() public orderedMenuRoles: any[] = [];
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Input() public createNewText1Part = "Select an existing record or click on";
  @Input() public createNewText2Part = "to create a new record";
  @Input() public editText = "to edit the record";
  @Input() public addText = "to add a new record";
  @Input() public createText = "Create";
  @Input() public renameText = "Click on the record name to rename the record";
  @Input() public operationalText = "to make the record operational or not";
  @Input() public deleteText = "to delete the record";
  @Input() public showOperational: boolean;
  @Input() public nameFieldKey = "name";
  @Input() public hash = "";
  @Input() public baseUrl = "";
  @Input() public newItem: any = {};
  @Input() public newItemModeEnabled: boolean;
  @Input() public toggleIcons: boolean = true;
  @Input() public disabledToggleIcons: boolean = false;
  @Input() public statusIcons: boolean = false;
  @Input() public badgeIcons: boolean = false;
  @Input() public inlineAdd: boolean = true;
  @Input() public sortable: boolean = false;
  @Input() public listToggle: boolean = false;
  @Input() public expanded: boolean = false;
  @Input() public hideSearch: boolean = false;
  @Input() public showAddWithoutSearch: boolean = false;
  @Input() public defaultSortKey: any = "sortOrder";
  @Input() public defaultSortKeyType: any = "number";
  @Input() public navigationEdit: boolean = true;
  @Input() public showAttributes: boolean = true;
  @Input() public addToParentText: string;
  @Input() public removeFromParentText: string;
  @Input() public multipleSelect: boolean = false;
  @Input() public customFilter: any;
  @Input() public hasFieldNumber: boolean = false;
  @Input() public hasUsagesColumn: boolean = false;
  @Input() public showHeader: boolean = true;
  @Input() public botType: string;
  @Input() public hasTutorial: boolean = false;
  @Input() public hasFilters: boolean = false;
  @Input() public botCounters: boolean = false;
  @Input() public roleCounters: boolean = false;
  @Input() public showItemStatus: boolean = false;
  @Input() public isCollapsible: boolean = false;
  @Input() public isCollapsed: boolean = false;
  @Input() public institutions: Institution[] = [];
  @Input() public readOnly: boolean = false;
  @Input() public muleServices: any[] = [];
  @Input() public counterLabel: string = "Used";
  @Input() public counterSortKey: string = "items";
  @Input() public showDuplicateIndicator: boolean = false;
  @Input() public itemErrorCounts: { [key: string]: number } = {};

  @Input() public hasPagination: boolean = false;
  @Input() public page: number = 1;
  @Input() public pageSize: number = 30;
  @Input() public totalPages: number = 1;
  @Output() public updatePage = new EventEmitter();
  public updatePageSender: any;

  @Input() public context: Context = null;
  @Input() public contextProperty: string;
  @Input() public tutorialProperty: string;

  @Output() public saveTutorial = new EventEmitter();
  @Output() public updateFunction = new EventEmitter();
  @Output() public sortFunction = new EventEmitter();
  @Output() public createFunction = new EventEmitter();
  @Output() public editFunction = new EventEmitter();
  @Output() public deleteFunction = new EventEmitter();
  @Output() public toggleOperationalFunction = new EventEmitter();
  @Output() public addToParentFunction = new EventEmitter();
  @Output() public removeFromParentFunction = new EventEmitter();
  @Output() public filterBy = new EventEmitter();
  @Output() public determinantSelectionChanged = new EventEmitter();
  @Output() public toggleFilter = new EventEmitter();
  @Output() public usagesClick = new EventEmitter();
  @Input() public showImport: boolean = false;
  @Input() public showStatus: boolean = false;
  @Input() public selectAll: boolean = false;
  @Input() public showCopyButton: boolean = false;
  @Output() public requestCopy = new EventEmitter();
  public selectedItem: any;
  public showWarningModal = false;
  public selectedForDeleteItem: any;
  public paneToShow: PaneToShow = PaneToShow.SEARCH;
  public renamedItem: string = null;
  public isRolesPage: boolean = false;
  public searchTextFilterObject: any;

  public itemRenameId: any = null;
  public itemEditAssignToId: any = null;
  public itemEditValue: any = null;
  public itemEditObj: any = null;

  // For pages tutorials
  public systemProperties: SystemProperties;

  // multiple elements delete
  public showMultipleModal: boolean = false;
  public selectedItems: any[] = [];

  // Sort variables
  private alphabeticalOrderReference: any = { value: true, key: true };
  public lastOrder: any = null;

  @ViewChild("newServiceNameInput")
  public newServiceNameInput: ElementRef;

  @ViewChild("searchInput")
  public searchInput: ElementRef;

  public searchValue: string = "";

  // Sort variables
  public sortKey: string = "";
  public ascending: boolean = false;
  public metadataMode: "modified" | "created" = "modified";
  public type: string = "";

  constructor(private router: Router,
    public store: Store,
    private systemPropertiesControllerService: SystemPropertiesControllerService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit(): void {
    if (this.context) {
      this.initTutorials();
    }
    this.route.params.subscribe((params) => {
      this.ngOnChanges();
    });
  }

  public askForCopy(event: any, id: any): void {
    event.stopPropagation();
    this.requestCopy.emit(id);
  }

  public toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }

  public initTutorials() {

    // this.systemPropertiesControllerService.getServiceProperties().subscribe(
    //   (data) => {
    //     this.systemProperties = data;
    //     if (!this.systemProperties.tutorials) { this.systemProperties.tutorials = {}; }
    //     if (!this.systemProperties.tutorials[this.context]) { this.systemProperties.tutorials[this.context] = {}; }
    //     this.pageTutorials = this.systemProperties.tutorials[this.context];
    //   },
    //   (error) => {
    //     this.pageTutorials = {};
    //     return this.error(this.getMessage(error), "Error getting system properties");
    //   },
    // );
  }

  public ngOnChanges(): void {
    if (this.items) {
      if (this.hash) {
        const selected = this.items.find((item => item.id === this.hash));
        if (selected) {
          this.editFunction.emit(selected);
        }
      } else {
        this.selectedItem = this.items.find((item) => {
          if (item.id) {
            const href = window.location.href;
            const id = item.id.toString();
            return href.substr(-id.length) === id;
          }
        });
      }

      this.items.forEach((i) => {
        i.selectedForDeletion = false;
      });
      this.newItemModeEnabled = window.location.href.includes("new");
      this.isRolesPage = window.location.href.includes("roles");
    }
    if (this.customFilter !== undefined) {
      this.searchTextChanged(this.customFilter, false);
    }
  }

  public ngOnDestroy() {
    this.paneToShow = PaneToShow.SHOW;
    delete this.searchTextFilterObject;
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // component logic
      this.fixItemsSort();
    }
  }

  public fixItemsSort() {
    this.items.forEach((it, index, itemsArray) => {
      itemsArray[index].sortOrder = index;
    });
    this.sortFunction.emit(this.items);
    this.resetSortVariables();
  }

  public toggleOperational(item) {
    this.toggleOperationalFunction.emit(item);
  }

  public showIconFor(item) {
    if (item.isLoading) {
      return "fa-spinner fa-spin";
    }
    if (item.active) {
      return "fa-toggle-large-on";
    }
    if (item.hidden === false) {
      return "fa-toggle-large-on";
    }
    return "fa-toggle-large-on fa-flip-horizontal";
  }

  public showInProcessFor(item) {
    if (item.sortOrderNumber >= 100) {
      return "fa-toggle-large-on fa-flip-horizontal";
    }
    return "fa-toggle-large-on";
  }

  public cancelInput(event) {
    if (this.itemEditObj !== null) {
      this.cancelEdit();
    }
    if (this.paneToShow === PaneToShow.ADD) {
      this.cancelCreate();
    }
  }

  public submitInput(event) {
    const ENTER = 13;
    if (event.keyCode === ENTER) {
      if (this.itemEditObj !== null) {
        this.submitRename();
      } else if (this.paneToShow === PaneToShow.ADD && this.newItem.name) {
        this.submitCreate();
      }
    }
  }

  public getBotRoleType(role) {
    let countData = 0;
    let countDocument = 0;
    let countInternal = 0;
    let countMessage = 0;
    if (role?.botRoleBots?.actions?.length) {
      role?.botRoleBots?.actions.forEach((a) => {
        switch (a.bots[0]?.botType) {
          case "internal":
            countInternal++;
            break;
          case "document":
            countDocument++;
            break;
          case "data":
            countData++;
            break;
          case "message":
            countMessage++;
            break;
        }
      });
      if (countData === 0 && countDocument === 0 && countInternal === 0 && countMessage === 0) {
        return "empty";
      } else if (countData > 0 && countDocument === 0 && countInternal === 0 && countMessage === 0) {
        return "data";
      } else if (countData === 0 && countDocument > 0 && countInternal === 0 && countMessage === 0) {
        return "document";
      } else if (countData === 0 && countDocument === 0 && countInternal > 0 && countMessage === 0) {
        return "internal";
      } else if (countData === 0 && countDocument === 0 && countInternal === 0 && countMessage > 0) {
        return "message";
      } else {
        return "mixed";
      }
    } else {
      return "empty";
    }
  }

  public revealCreateInput() {
    this.cancelEdit();
    this.paneToShow = PaneToShow.ADD;
    setTimeout(() => {
      this.newServiceNameInput.nativeElement.focus();
    }, 500);
  }

  public cancelCreate() {
    this.paneToShow = PaneToShow.SEARCH;
  }

  public submitCreate() {
    this.createFunction.emit(this.newItem);
    this.paneToShow = PaneToShow.SEARCH;
    this.newItem.name = "";
    this.newItem.isLoading = true;
  }

  public cancelEdit() {
    this.itemEditObj = null;
    this.itemEditValue = null;
    this.itemRenameId = null;
    this.itemEditAssignToId = null;
  }

  public submitRename() {
    this.itemEditObj.isLoading = true;
    this.itemEditObj[this.nameFieldKey] = this.itemEditValue;
    this.updateFunction.emit(this.itemEditObj);
    this.cancelEdit();
  }

  public renameItem(item, event) {
    event.stopPropagation();
    this.cancelCreate();
    this.itemEditObj = item;
    this.itemEditValue = item[this.nameFieldKey];
    this.itemRenameId = item.id;
  }

  public toggleBot(item, event) {
    event.stopPropagation();
    this.cancelCreate();
    this.cancelEdit();
    this.itemEditObj = item;
    this.itemEditObj.type = this.itemEditObj.type === "UserRole" ? "BotRole" : "UserRole";
    this.updateFunction.emit(this.itemEditObj);
  }

  public toggleStartRole(item, event) {
    event.stopPropagation();
    this.cancelCreate();
    this.cancelEdit();
    this.itemEditObj = item;
    this.itemEditObj.startRole = !this.itemEditObj.startRole;
    this.updateFunction.emit(this.itemEditObj);
  }

  public editAssignedTo(item, event) {
    event.stopPropagation();
    this.cancelCreate();
    this.cancelEdit();
    this.itemEditObj = item;
    this.itemEditValue = item.assignedTo;
    this.itemEditAssignToId = item.id;
  }

  public changeAssignedTo(event) {
    event.stopPropagation();
    this.itemEditObj.assignedTo = this.itemEditValue;
    this.updateFunction.emit(this.itemEditObj);
    this.cancelEdit();
  }

  public onAddToParentClick(event: any, item: any): void {
    event.stopPropagation();
    this.addToParentFunction.emit(item);
  }

  public onRemoveFromParentClick(item: any): void {
    this.removeFromParentFunction.emit(item);
  }

  public onDeleteClick(event: any, item: any): void {
    this.selectedForDeleteItem = item;
    this.showWarningModal = true;
    event.stopPropagation();
  }

  public delete(isConfirmed: boolean) {
    if (isConfirmed) {
      this.deleteFunction.emit(this.selectedForDeleteItem);
    }
    this.showWarningModal = false;
  }

  public getSelectedItem(): string {
    if (this.selectedForDeleteItem) {
      return this.selectedForDeleteItem[this.nameFieldKey];
    } else {
      return "";
    }
  }

  public getSelectedItems(): string {
    if (this.selectedItems.length) {
      let text = "";
      this.selectedItems.forEach((i, index) => {
        text += index === 0 ? i.name : ", " + i.name;
      });
      return text;
    } else {
      return "";
    }
  }

  public revealSearchPane() {
    this.paneToShow = PaneToShow.SEARCH;
    setTimeout(() => {
      if (this.searchInput && this.searchInput.nativeElement) {
        this.searchInput.nativeElement.focus();
      }
    }, 500);
  }

  public isShowPaneActivated() {
    return this.paneToShow === PaneToShow.SHOW;
  }

  public isAddPaneActivated() {
    return this.paneToShow === PaneToShow.ADD;
  }

  public isSearchPaneActivated() {
    return this.paneToShow === PaneToShow.SEARCH;
  }

  public editItem(item) {
    if (this.navigationEdit) {
      this.router.navigate([this.baseUrl + "/" + item.id]);
    } else {
      if (this.hash) {
        this.hash = '';
        window.location.hash = '';
      }
      this.editFunction.emit(item);
    }
  }

  public searchTextChanged(value, emit: boolean = true) {
    if (this.hasPagination) {
      this.searchValue = value;
      this.newItem.name = value;
      if (this.updatePageSender) {
        clearTimeout(this.updatePageSender);
      }
      this.updatePageSender = setTimeout(() => {
        this.searchPage();
      }, 2000);
    } else {
      const filter = {};
      filter[this.nameFieldKey] = value;
      this.searchTextFilterObject = filter;
      if (emit) {
        this.filterBy.emit(value);
      } else {
        this.searchValue = value;
      }
      this.newItem.name = value;
    }
  }

  public closeSearchPane() {
    this.paneToShow = PaneToShow.SHOW;
    delete this.searchTextFilterObject;
  }

  public setListView(b) {
    this.listToggle = b;
  }

  public goToAdd() {
    this.createFunction.emit(this.newItem);
    this.newItem = {};
  }

  public resetSearch() {
    this.searchValue = "";
    this.searchTextFilterObject = null;
    this.filterBy.emit("");
    if (this.hasPagination) {
      this.searchPage();
    }
  }

  public sortElements(key: string, type: any): void {
    this.ascending = key !== this.sortKey ? false : this.ascending;
    this.type = type;
    this.sortKey = key;
    this.alphabeticalOrderReference[key] = !this.alphabeticalOrderReference[key];
    this.lastOrder = Object.assign([], this.items);
    this.items.sort((fieldA, fieldB) => {
      return this.alphabeticalOrderReference[key]
        ? (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? -1 : 1)
        : (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? 1 : -1);
    });
    this.ascending = !this.ascending;
  }

  public sortItems(sortKey: string) {
    // if different key, start from ascending false
    this.ascending = sortKey !== this.sortKey ? false : this.ascending;
    if (this.hasPagination) {
      this.sortPage(sortKey);
    } else {
      this.items.sort((a, b) => {
        let valueA = a[sortKey];
        let valueB = b[sortKey];

        const numberValueA = Number(valueA);
        const numberValueB = Number(valueB);

        if (isNaN(valueA) && isNaN(valueB)) {
          valueA = Date.parse(valueA);
          valueB = Date.parse(valueB);
        } else {
          valueA = numberValueA;
          valueB = numberValueB;
        }

        if (valueA < valueB) { return this.ascending ? -1 : 1; }
        if (valueA > valueB) { return this.ascending ? 1 : -1; }
        return 0;
      });
    }
    // set the current sortKey
    this.sortKey = sortKey;
    this.ascending = !this.ascending;
  }

  public toggleMetadataMode(mode: "modified" | "created") {
    const sortKey = mode === "modified" ? "lastChangedWhen" : "createdWhen";
    if (this.metadataMode === mode) {
      // clicking the already-active button toggles sort direction
      this.sortItems(sortKey);
    } else {
      this.metadataMode = mode;
      this.sortKey = sortKey;
      this.ascending = false;
      this.sortItems(sortKey);
    }
  }

  public resetSortVariables() {
    this.sortKey = "";
    this.ascending = false;
  }

  private getFilteredItems(): any[] {
    if (!this.searchValue || this.hasPagination) {
      return this.items;
    }

    const searchStringFormatted = this.searchValue.toLowerCase();

    return this.items.filter((it) => {
      const name = it.name ? it.name.toLowerCase().includes(searchStringFormatted) : false;
      const createdBy = it.createdBy ? it.createdBy.toLowerCase().includes(searchStringFormatted) : false;
      const createdById = it.createdById ? it.createdById.toLowerCase().includes(searchStringFormatted) : false;
      const lastChangedBy = it.lastChangedBy ? it.lastChangedBy.toLowerCase().includes(searchStringFormatted) : false;
      const lastChangedById = it.lastChangedById ? it.lastChangedById.toLowerCase().includes(searchStringFormatted) : false;
      const lastPublishedBy = it.lastPublishedBy ? it.lastPublishedBy.toLowerCase().includes(searchStringFormatted) : false;
      const lastPublishedById = it.lastPublishedById ? it.lastPublishedById.toLowerCase().includes(searchStringFormatted) : false;
      return (name || lastChangedBy || createdBy || createdById || lastChangedById || lastPublishedById || lastPublishedBy);
    });
  }

  public selectItem(item, event): void {
    item.selectedForDeletion = event.target.checked;
    if (event.target.checked) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  public selectAllItems(items, event): void {
    const filteredItems = this.getFilteredItems();
    filteredItems.forEach((item) => {
      this.selectItem(item, event);
      this.isSelected(item);
    });
  }

  public deleteSelectedItems(): void {
    this.showMultipleModal = true;
  }

  public deleteItems(): void {
    this.deleteFunction.emit(this.selectedItems);
    // clear selected items
    this.selectedItems = [];
    // hide confirmation modal
    this.showMultipleModal = false;
  }

  public isSelected(item): boolean {
    const exist = this.selectedItems.filter((i) => i.id === item.id);
    return exist.length > 0;
  }

  public hasSelectedItems(items): boolean {
    const filteredItems = this.getFilteredItems();
    return filteredItems.length === this.selectedItems.length && this.selectedItems.length > 0;
  }

  public onDeterminantSelectionChanged(event): void {
    this.determinantSelectionChanged.emit(event);
  }

  public toggleFilters(event): void {
    this.toggleFilter.emit(true);
  }

  public formatRoles(items) {
    let roles = "";
    items.forEach((i, index) => {
      if (index > 0) {
        roles += "\n";
      }
      roles += `${i.name}`;
    });
    return roles;
  }

  public formatActions(items) {
    let actions = "";
    items.forEach((i, index) => {
      if (index > 0) {
        actions += "\n";
      }
      if (i.type) { actions += this.translate.instant(i.type) + ": "; }
      actions += `${i.fullName || i.name || i.entityId}`;
    });
    return actions;
  }

  // Pagination
  public pageNumber() {
    const pages = [];
    let index = 1;
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(index);
      index++;
    }
    return pages;
  }

  public checkMessageBot(b: any) {
    return b.selectedMessage && b.selectedReceiver;
  }

  public checkLinkBot(b: any) {
    return b.isEregistrationService;
  }

  public sortPage(sortKey: string) {
    this.updatePage.emit({ page: 1, trigger: "sort", asc: this.ascending ? "asc" : "desc", sortKey });
  }

  public searchPage() {
    const newSearchValue = this.searchValue.replace(/{/g, "%7B").replace(/}/g, "%7D");
    this.updatePage.emit({ page: 1, trigger: "search", filter: newSearchValue });
  }

  public setPage(index: number) {
    this.updatePage.emit({ page: index, trigger: "page" });
  }
}
